import './App.scss';

import { BrowserRouter as Router, Route, Routes } from "react-router-dom";
import Products from './components/Products';
import Home from './components/Home';

function App() {
  return (
    <Router>
      <div className='body'>
        <Routes>
          <Route path="/gifts" element={<Products />} />
          <Route path="/fiesta" element={<Home full/>} />
          <Route path="/fiesta!" element={<Home plusone/>} />
          <Route path="/post" element={<Home post10/>} />
          <Route path="/*" element={<Home/>} />
        </Routes>
      </div>
   </Router>
  );
}

export default App;
